import icon from 'vue-svgicon';

icon.register({
    'bold/check-double-1': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M23.223 2.058a1.5 1.5 0 0 0-2.037.591L12.693 18.08l-6.231-6.794a1.5 1.5 0 1 0-2.211 2.027l7.643 8.335a1.518 1.518 0 0 0 2.42-.291l9.5-17.257a1.5 1.5 0 0 0-.591-2.042zM2.605 14.625a1.5 1.5 0 0 0-2.211 2.028l4.581 5a1.517 1.517 0 0 0 2.119.091 1.5 1.5 0 0 0 .092-2.119z"/><path pid="1" d="M10.3 12.973a1.407 1.407 0 0 0 2.01-.54L16.894 4.1a1.5 1.5 0 1 0-2.627-1.446l-4.589 8.332a1.425 1.425 0 0 0 .622 1.987z"/>`,
    },
});
